module.exports = __webpack_public_path__ + "static/media/Version 2 Option 3 Screen A.390b5206.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/smartinsure/Version 2 Option 3 Screen A.png
// module id = 630
// module chunks = 0